import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Button, Input } from 'antd';
import { CodeOutlined, DesktopOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface RichTextEditorProps {
    value?: string;
    onChange?: (content: string) => void;
    placeholder?: string;
    height?: number | string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value = '',
    onChange,
    placeholder,
    height = 300
}) => {
    const [isSourceMode, setIsSourceMode] = React.useState(false);
    
    // Ensure value is always at least an empty string for the editors
    const safeValue = value || '';

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image'],
            ['clean'],
            ['code-block']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list',
        'link', 'image',
        'color', 'background',
        'code-block'
    ];

    return (
        <div className="rich-text-editor" style={{ marginBottom: '10px' }}>
            <div style={{ marginBottom: '8px', textAlign: 'right' }}>
                <Button 
                    size="small" 
                    icon={isSourceMode ? <DesktopOutlined /> : <CodeOutlined />} 
                    onClick={() => setIsSourceMode(!isSourceMode)}
                >
                    {isSourceMode ? 'Visual Editor' : 'Source Code'}
                </Button>
            </div>
            
            {isSourceMode ? (
                <TextArea
                    value={safeValue}
                    onChange={(e) => onChange?.(e.target.value)}
                    placeholder={placeholder}
                    style={{ 
                        height: height, 
                        fontFamily: 'monospace', 
                        fontSize: '13px',
                        background: '#1e1e1e',
                        color: '#d4d4d4',
                        marginBottom: '10px'
                    }}
                />
            ) : (
                <ReactQuill
                    key={isSourceMode ? 'source' : 'visual'} // Ensure re-render when switching modes
                    theme="snow"
                    value={safeValue}
                    onChange={(content) => onChange?.(content)}
                    modules={modules}
                    formats={formats}
                    placeholder={placeholder}
                    style={{ height: height, marginBottom: '50px' }} // Bottom margin for the toolbar/info
                />
            )}
        </div>
    );
};

export default RichTextEditor;
